module.exports = __webpack_public_path__ + "static/c1-ed8ede75672663f9f7659b24613edcb4.jpg";